export type Indexable = Record<string, unknown> | Array<unknown>;

export function isIndexable(value: unknown): value is Indexable {
    return (
        value !== null && (Array.isArray(value) || typeof value === 'object')
    );
}
